<template>
  <div class="container">
    <el-button type="text" size="w" @click="showRegionTask"
      >识别框目标</el-button
    >
    <el-dialog
      title="识别框类别标注的目标"
      :visible.sync="regionTaskShow"
      width="400"
    >
      <el-button type="text" size="mini" @click="emitEdit" v-if="!editFlag"
        >修改目标</el-button>
      <el-button type="text" size="mini" @click="confirmEdit" v-if="editFlag"
        >确认修改</el-button
      >
      <el-button
        type="text"
        size="mini"
        @click="cancelEdit"
        v-if="editFlag"
        class="danger-text"
        >取消</el-button
      >
      <el-table :data="list" style="width: 100%" height="400px">
        <el-table-column
          prop="category"
          label="图框"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="category_desc"
          label="图框类别"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column label="目标总数" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="editFlag"
              v-model.number="targetList[scope.$index]"
            ></el-input>
            <span v-else>{{ scope.row.target_number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已标总数" header-align="center" align="center">
          <template slot-scope="scope">
            <i class="el-icon-loading primary-text" v-if="loading"></i>
            <span v-else>
              {{ scope.row.count }}
            </span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="是否达成">
          <template slot-scope="scope">
            <i class="el-icon-loading primary-text" v-if="loading"></i>
            <span v-else>
              <el-tag
                size="mini"
                type="success"
                v-if="scope.row.count >= scope.row.target_number"
                >已达成</el-tag
              >
              <el-tag type="danger" size="mini" v-else>未达成</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <i class="el-icon-loading primary-text" v-if="loading"></i>
            <el-button v-else type="text" size="mini" @click="generateZip(scope.row.category)">生成zip</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  apiGetCategoryCount,
  apiUpdateCategoryTarget,
  apiGetAllCategoryList,
  apiGenerateZip
} from "@/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      loading: false,
      editFlag: false,
      regionTaskShow: false,
      targetForm: [],
      categoryCount: [],
      targetList: []
    };
  },
  mounted() {
    // this.targetForm = this.category_list;
    this.getCategoryList();
  },
  methods: {
    async generateZip(category) {
      this.$prompt('请输入任务备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入备注',
        inputValidator: val => !!val
      }).then(async({value}) => {
        console.log(value);
        try {
          await apiGenerateZip([category], value);
          this.$message.success('zip任务已生成');
        } catch (e) {
          this.$message.error('生成失败' + e.message);
        }
      }).catch(e => {
        this.$message.error('您已取消');
      });
    },
    async getCategoryList() {
      try {
        const res = await apiGetAllCategoryList();
        this.$store.commit("SET_ALL_CATEGORY_LIST", res);
      } catch (e) {
        console.log(e);
        this.$message.error("图框大类查询失败" + e.message);
      }
    },
    emitEdit() {
      this.editFlag = true;
      this.targetList = this.category_list.map(a => a.target_number);
    },
    cancelEdit() {
      this.editFlag = false;
      this.targetList = [];
    },
    async confirmEdit() {
      let target = this.category_list.map((a, index) => {
        return {
          category: a.category,
          target_number: this.targetList[index]
        };
      });
      try {
        await apiUpdateCategoryTarget(target);
        this.$message.success("修改成功");
        this.getCategoryList();
        this.cancelEdit();
      } catch (e) {
        console.log(e);
        this.$message.error("修改失败" + e.message);
      }
      console.log(target);
    },
    findTarget(row) {
      console.log(
        this.$_.find(this.category_list, a => a.category === row.category)
      );
      return this.$_.find(this.category_list, a => a.category === row.category);
    },
    showRegionTask() {
      this.regionTaskShow = true;
      this.getCategoryCount();
      try {
      } catch (e) {}
    },
    async getCategoryCount() {
      try {
        this.loading = true;
        this.categoryCount = await apiGetCategoryCount();
        // this.$store.commit('emitLoading')
        this.loading = false;
        // this.categoryCount = categoryCount;
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.$message.error("查询识别框总数失败" + e.message);
      }
    }
  },
  computed: {
    ...mapGetters(["category_list"]),
    list() {
      return this.category_list.map(a => {
        const tar = this.$_.find(
          this.categoryCount,
          b => b.category === a.category
        );
        if (tar) {
          this.$set(a, "count", tar.count);
        }
        return a;
      });
    }
  },
  watch: {
    regionTaskShow(val) {
      if (val === false) {
        this.editFlag = false;
        this.cancelEdit();
      }
    }
  }
};
</script>
<style></style>
